import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MapServiceConstants } from "../components/map-services/map-service.constants";
import { map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { ApiModuleMapConstants } from "../../../shared/constants/api-constants/api-module-map.constants";
import { ApiProxyConstants } from "../../../shared/constants/api-constants/api-proxy.constants";
import { PropertySearchOption } from "../../../tabs/properties/shared/models/property-heading.model";
import { PoiSearchOption } from "../../../tabs/poi/shared/enums/poi-search-enum";
import { BaySearchOption } from "../../../tabs/bays/shared/Enums/bay-search-enum";
import { CemeterySearchOption } from "../../../tabs/graves/shared/models/cemetery/cemetery-search-option.enum";
import { GraveSearchOption } from "../../../tabs/graves/shared/models/grave/grave-search-option.enum";
import { StreetSearchOption } from "../../../tabs/streets/shared/enums/street-search-enum";
let MapServiceService = class MapServiceService {
    http;
    mapConfigURL = ApiModuleMapConstants.URL;
    layerUrlList = new BehaviorSubject(null);
    layerUrlListAsObservable = this.layerUrlList.asObservable();
    constructor(http) {
        this.http = http;
    }
    setPropertyMapLayers(urlList) {
        this.layerUrlList.next(urlList);
    }
    checkMapLayers() {
        const params = {
            $select: "moduleId,selectionLayerType,url",
            $orderby: "moduleId,selectionLayerType"
        };
        return this.http.get(this.mapConfigURL, { params }).pipe(map((response) => {
            const mapUrlList = [];
            response.value.forEach((res) => {
                const layerType = res.selectionLayerType ? this.getMapLayerType(res.selectionLayerType) : null;
                if (layerType) {
                    const newMapUrl = {
                        moduleId: res.moduleId,
                        url: res.url,
                        layerType
                    };
                    mapUrlList.push(newMapUrl);
                }
            });
            return mapUrlList;
        }));
    }
    getMapLayerType(selectionLayerType) {
        switch (selectionLayerType) {
            case MapServiceConstants.PROPERTY_OWNER_LAYER:
                return PropertySearchOption.PropertyOwner;
            case MapServiceConstants.PROPERTY_ZONING_LAYER:
                return PropertySearchOption.PropertyZoning;
            case MapServiceConstants.PROPERTY_LAYER:
                return PropertySearchOption.Property;
            case MapServiceConstants.CEMETERY_LAYER:
                return CemeterySearchOption.Cemetery;
            case MapServiceConstants.GRAVE_LAYER:
                return GraveSearchOption.Grave;
            case MapServiceConstants.BAYS_LAYER:
                return BaySearchOption.Bay;
            case MapServiceConstants.POI_LAYER:
                return PoiSearchOption.Poi;
            case MapServiceConstants.STREET_LAYER:
                return StreetSearchOption.Street;
        }
    }
    getMaps(moduleId, tableItems) {
        const params = {
            $filter: `moduleId eq ${moduleId}`,
            $orderby: "name"
        };
        return this.http.get(this.mapConfigURL, { params }).pipe(map((response) => {
            Object.keys(response.value).forEach((element) => {
                if (!response.value[element].authType) {
                    response.value[element].authType = "None";
                }
                if (response.value[element].showInAflaPortal === true) {
                    response.value[element].showInAflaPortalDisplay = "Yes";
                }
                else {
                    response.value[element].showInAflaPortalDisplay = "No";
                }
                response.value[element].validate = "Not validated";
                const attachmentLabel = response.value[element].url;
                response.value[element].urlLink = {
                    text: attachmentLabel,
                    address: response.value[element].url,
                    clickAction: () => {
                        if (attachmentLabel !== "") {
                            window.open(attachmentLabel, "_blank");
                        }
                    }
                };
                tableItems.push(response.value[element]);
            });
            return response.value;
        }));
    }
    saveNewMap(newMap) {
        return this.http.post(this.mapConfigURL, newMap);
    }
    updateMap(key, editMap) {
        return this.http.patch(`${this.mapConfigURL}/${key}`, editMap);
    }
    removeMap(id) {
        return this.http.delete(`${this.mapConfigURL}/${id}`);
    }
    checkUrl(url, token) {
        const params = {
            f: "json"
        };
        if (token) {
            params.token = token;
        }
        return this.http.get(url, { params });
    }
    checkSecureUrl(url, username, password, clientId, secret, authType) {
        let params;
        if (authType === "Agol" || authType === "Portal OAuth") {
            params = {
                url,
                clientId,
                secret,
                authType
            };
        }
        else {
            params = {
                url,
                username,
                password,
                authType
            };
        }
        return this.http.get(ApiProxyConstants.FUNCTION_CHECK_SECURE_URL, { params });
    }
    getServiceInfo(url, authType, username, password, clientId, secret) {
        if (authType && authType !== "None") {
            return this.checkSecureUrl(url, username, password, clientId, secret, authType);
        }
        return this.checkUrl(url);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
MapServiceService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MapServiceService);
export { MapServiceService };
